import React, { FC } from 'react';
import { SensorDefaultsProvider } from './pages/eventValueRage/context/SensorDefaultsContext';
import { TanstackTableLocaleSetup } from './components/TanstackTableLocaleSetup';

export const ContextProviders: FC<Props> = ({ children }: Props) => {
  return (
    <SensorDefaultsProvider>
      <TanstackTableLocaleSetup>{children}</TanstackTableLocaleSetup>
    </SensorDefaultsProvider>
  );
};

interface Props {
  children: React.ReactNode;
}
